import Image from 'Component/Image';
import Link from 'Component/Link';
import TextPlaceholder from 'Component/TextPlaceholder';
import {
    CategoryDetails as SourceCategoryDetails
} from 'SourceComponent/CategoryDetails/CategoryDetails.component';

import './CategoryDetails.override.style';

/** @namespace Elganso/Component/CategoryDetails/Component */
export class CategoryDetailsComponent extends SourceCategoryDetails {
    renderCategoryText() {
        const {
            category: { meta_title, name },
            isCurrentCategoryLoaded
        } = this.props;

        if (isCurrentCategoryLoaded) {
            return (
                <TextPlaceholder content={ meta_title || name } />
            );
        }

        return (
            <TextPlaceholder />
        );
    }

    renderCategoryDescriptionPlaceholder() {
        return null;
    }

    renderCategoryImage() {
        const {
            category: { image, id, customizedAttributes },
            isCurrentCategoryLoaded
        } = this.props;

        if (!id || !isCurrentCategoryLoaded) {
            return this.renderCategoryImagePlaceholder();
        }

        if (!image) {
            return null;
        }

        if (customizedAttributes.bannerLink) {
            return (
                <Link
                  block="CategoryDetails"
                  elem="link"
                  to={ customizedAttributes.bannerLink }
                >
                    <Image
                      mix={ { block: 'CategoryDetails', elem: 'Picture' } }
                      src={ image || '' }
                      ratio="custom"
                      objectFit="cover"
                    />
                </Link>
            );
        }

        return (
            <Image
              mix={ { block: 'CategoryDetails', elem: 'Picture' } }
              src={ image || '' }
              ratio="custom"
              objectFit="cover"
            />
        );
    }

    render() {
        return (
            <article block="CategoryDetails">
                { this.renderCategoryImage() }
                <div block="CategoryDetails" elem="Description">
                    { this.renderCategoryName() }
                    { this.renderCategoryDescription() }
                </div>
            </article>
        );
    }
}

export default CategoryDetailsComponent;
